import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";
import { Mail, Users, ListChecks, FileText, ShieldOff, Settings, ShieldCheck } from "lucide-react";
import CampaignsTab from "./CampaignsTab";
import ContactsTab from "./ContactsTab";
import VerificationTab from "./VerificationTab";
import ListsTab from "./ListsTab";
import TemplatesTab from "./TemplatesTab";
import SuppressionsTab from "./SuppressionsTab";
import MarketingSettingsTab from "./MarketingSettingsTab";

export const getAdminAuth = () => {
  const token = localStorage.getItem("token");
  return { headers: token ? { Authorization: `Bearer ${token}` } : {} };
};
export const MKT = `${process.env.REACT_APP_BACKEND_URL}/api/admin/marketing`;

export default function AdminEmailMarketing() {
  const [meta, setMeta] = useState(null);
  const [tab, setTab] = useState("campaigns");
  const [listTarget, setListTarget] = useState(null); // list picked in ListsTab → preselected in ContactsTab

  const refreshMeta = async () => {
    try {
      const res = await axios.get(`${MKT}/meta`, getAdminAuth());
      setMeta(res.data);
    } catch (e) { /* handled by admin shell */ }
  };
  useEffect(() => { refreshMeta(); }, []);

  return (
    <div className="space-y-5" data-testid="email-marketing-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
            <Mail className="w-6 h-6 text-blue-500" /> Email Marketing
          </h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Outbound marketing to prospective field-service businesses — fully separate from transactional email
          </p>
        </div>
        {meta && (
          <div className="flex gap-4 text-xs text-muted-foreground">
            <span><b className="text-foreground">{meta.totals.contacts}</b> contacts</span>
            <span><b className="text-foreground">{meta.totals.lists}</b> lists</span>
            <span><b className="text-foreground">{meta.totals.campaigns}</b> campaigns</span>
            <span><b className="text-foreground">{meta.totals.suppressions}</b> suppressed</span>
          </div>
        )}
      </div>

      <Tabs value={tab} onValueChange={(v) => { setTab(v); if (v !== "contacts") setListTarget(null); }}>
        <TabsList className="flex flex-wrap h-auto">
          <TabsTrigger value="campaigns" data-testid="tab-campaigns"><Mail className="w-3.5 h-3.5 mr-1.5" />Campaigns</TabsTrigger>
          <TabsTrigger value="contacts" data-testid="tab-contacts"><Users className="w-3.5 h-3.5 mr-1.5" />Contacts</TabsTrigger>
          <TabsTrigger value="verification" data-testid="tab-verification"><ShieldCheck className="w-3.5 h-3.5 mr-1.5" />Verification</TabsTrigger>
          <TabsTrigger value="lists" data-testid="tab-lists"><ListChecks className="w-3.5 h-3.5 mr-1.5" />Lists</TabsTrigger>
          <TabsTrigger value="templates" data-testid="tab-templates"><FileText className="w-3.5 h-3.5 mr-1.5" />Templates</TabsTrigger>
          <TabsTrigger value="suppressions" data-testid="tab-suppressions"><ShieldOff className="w-3.5 h-3.5 mr-1.5" />Suppressions</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-mkt-settings"><Settings className="w-3.5 h-3.5 mr-1.5" />Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="campaigns"><CampaignsTab meta={meta} onChanged={refreshMeta} /></TabsContent>
        <TabsContent value="contacts"><ContactsTab meta={meta} onChanged={refreshMeta} listTarget={listTarget} /></TabsContent>
        <TabsContent value="verification"><VerificationTab onChanged={refreshMeta} /></TabsContent>
        <TabsContent value="lists"><ListsTab onChanged={refreshMeta} onPickContacts={(l) => { setListTarget(l); setTab("contacts"); }} /></TabsContent>
        <TabsContent value="templates"><TemplatesTab /></TabsContent>
        <TabsContent value="suppressions"><SuppressionsTab onChanged={refreshMeta} /></TabsContent>
        <TabsContent value="settings"><MarketingSettingsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
